import React, { Component } from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'
import { connect } from 'react-redux'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'

import { GetWithNonce } from 'utils/axios-nonce'
import { Get, Post, Put } from 'utils/axios-token'
import Lang from 'Lang/General'

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      showCreateFairs: false,
      loading: false,
      fairs: [],
      searchParams: [
        {
          label: 'Title',
          col: 6,
          value: 'title',
          param: ''
        },
        {
          label: 'Status',
          col: 6,
          value: 'is_active',
          param: '',
          type: 'select',
          options: [
            {
              id: 'true',
              name: Lang['ACTIVE'][this.props.data.languageReducer.userSettings.admin_panel_language]
            },
            {
              id: 'false',
              name: Lang['INACTIVE'][this.props.data.languageReducer.userSettings.admin_panel_language]
            },
          ]
        }
      ],
      fairsMeta: {
        current_page: 1,
        per_page: 10,
        last_page: 1,
        total_results: 1
      },
      defaultQuery: {},
      selectedFairs: null,
      showEditModal: false,
      subscribedPackage: false,
      showDeleteConfirmation: false,
      showViewFairsModal: false,
      countries: [],
      query: {},
      fairErrorMessage: {}
    }

    onChangeFairsHOC = (key, val) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success(success)
    requestError = error => {
      typeof error === 'string'
        ? toast.error( error )
        : Object.values( error ).map( err => toast.error( err.replace( /_/g, ' ' ) ) )
      typeof error !== 'string' && this.setState({ 
        fairErrorMessage: _.reduce( 
          error,  
          ( resError, errVal, errKey ) => ({ 
              ...resError, 
              [ errKey ] : errVal.replace( /_/g, ' ' )
            }),
          {}
        )
      })
    }

    getFairs = (query) => {
      this.setState({ query })

      Get(
        `/api/v1/fex/fairs?query=${convertSearchObjectToBase64(query)}`,
        this.getFairsSuccess,
        this.getFairsError,
        this.load
      )
    }
    getFairsSuccess = payload => this.setState({
      fairs: _.map(payload.data, item => ({ ...item, status: Lang[item.is_active ? 'ACTIVE' : 'INACTIVE'][this.props.data.languageReducer.userSettings.admin_panel_language] })),
      fairsMeta: payload.meta
    })
    getFairsError = error => this.requestError(error.toString())

    createFairs = dataToSubmit => {
      Post(
        `/api/v1/fex/fairs`,
        dataToSubmit,
        this.createFairsSuccess,
        this.createFairsError,
        this.load
      )
    }
    createFairsSuccess = () => {
      this.requestSuccess(Lang['RECORD_CREATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        showCreateFairs: false,
        query: {
          page: 1,
          is_paginated: true,
          filter: { "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id, }
        }
      }, () => this.getFairs(this.state.query))
    }
    createFairsError = error => {
      if (error.name) {
        this.requestError(error.name)
      } else {
        this.requestError(error)
      }
    }

    getSelectedFairs = id => {
      Get(
        `/api/v1/fex/fairs/${id}`,
        this.getSelectedFairsSuccess,
        this.getSelectedFairsError,
        this.load
      )
    }
    getSelectedFairsSuccess = payload => this.setState({ selectedFairs: payload, showEditModal: true })
    getSelectedFairsError = error => this.requestError(error)

    updateFairs = (dataToSubmit) => {
      Put(
        `/api/v1/fex/fairs/${dataToSubmit.id}`,
        dataToSubmit,
        this.updateFairsSuccess,
        this.updateFairsError,
        this.load
      )
    }
    updateFairsSuccess = () => {
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        showEditModal: false,
        selectedFairs: null,
        query: {
          page: 1,
          is_paginated: true,
          filter: { "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id, }
        }
      }, () => this.getFairs(this.state.query))
    }
    updateFairsError = error => this.requestError(error)

    getCountries = () => GetWithNonce(
      `/api/v1/countries?language=DEU`,
      this.getCountriesSuccess,
      this.getCountriesError,
      this.load
    )
    getCountriesSuccess = payload => {
      let tempOptions = []
      payload && payload.map(item => {
        tempOptions.push({
          id: item.alpha3,
          label: item.name,
          value: item.alpha3
        })
      })
      this.setState({ countries: tempOptions })
    }
    getCountriesError = error => this.requestError(error)

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoadFairsHOC={this.state.loading}
          getFairs={this.getFairs}
          getCountries={this.getCountries}
          createFairs={this.createFairs}
          getSelectedFairs={this.getSelectedFairs}
          updateFairs={this.updateFairs}
          onChangeFairsHOC={this.onChangeFairsHOC}
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect(mapStateToProps)(WithHOC)
}

export default HOC
